//src/features/FeatureEnum.ts
export enum FeatureEnum {
    GAME_1 = "Game1",
    GAME_2 = "Game2",
    GAME_3 = "Game3",
    BH_GAME = "BHGame",
    DEV_MENU = "DevMenu",
    PAUSE_MENU = "PauseMenu",
    SAVE_MENU = "SaveMenu",
    SETTINGS_MENU = "SettingsMenu",
    CONTINUE = "ContinueScreen",
    GAME_OVER = "GameOverScreen",
    SCORE_SCREEN = "ScoreScreen",
    MAIN_MENU = "MainMenu",
    CINEMATIC = "Cinematic",
}